import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { fetchRestaurants } from "../lib/api";
import RestaurantCard from "./RestaurantCard";

export default function RestaurantsPreview() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    fetchRestaurants().then((d) => setItems(d.slice(0, 6))).catch(() => {});
  }, []);

  return (
    <section id="restaurants-preview" data-testid="restaurants-preview-section" className="bg-neutral-50 py-24 sm:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-end justify-between gap-6 mb-12">
          <div>
            <div className="text-xs uppercase tracking-[0.3em] text-[#65A30D] font-bold">Trending Now</div>
            <motion.h2
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              className="font-display font-black text-4xl sm:text-5xl tracking-tighter mt-3 text-ink-900"
            >
              Top kitchens this week
            </motion.h2>
          </div>
          <Link
            to="/restaurants"
            data-testid="preview-see-all-link"
            className="hidden md:inline-flex items-center gap-2 text-sm font-semibold text-ink-900 hover:text-[#65A30D]"
          >
            See all <ArrowRight size={16} />
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((r, i) => (
            <motion.div
              key={r.id}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: i * 0.05 }}
            >
              <RestaurantCard r={r} idx={i} />
            </motion.div>
          ))}
        </div>

        <div className="mt-10 md:hidden">
          <Link
            to="/restaurants"
            data-testid="preview-see-all-mobile-link"
            className="inline-flex items-center gap-2 text-sm font-semibold text-ink-900"
          >
            See all <ArrowRight size={16} />
          </Link>
        </div>
      </div>
    </section>
  );
}
